export const css = {
    root: '_1tVWq4Tr',
    ' _key': 'afcpe-theme/afcpe/table-of-contents/trigger'
};
export default css;
